import React from "react";
import './privacypolicystyle.css';

function EMoniPrivacyPolicy() {

    const openNewTab = (url) => {
        window.open(url, '_blank')
    }
    return (
           <div class="container">
      <h1>Privacy Policy</h1>
      <p>
        Vodafone Cook Islands (“our, we or us”) is committed to protecting your personal information. We have created this Privacy Policy to help you understand how we collect, use and protect your information.
      </p>

      <p>
        If you want to talk to us about this Policy or any concerns or queries you have about the use of your personal information, please call us on 123 or 29680 or email us at <a href="mailto:info@vodafone.co.ck">info@vodafone.co.ck</a>.
      </p>

      <h2>1. We collect information about you. Here are some sources:</h2>
      <ol type="a">
        <li>Your application or registration form</li>
        <li>Your entry to a competition or promotion sponsored by us</li>
        <li>Customer surveys</li>
        <li>The way you use our products and services</li>
        <li>Correspondences between you and us related to the services we supply to you</li>
        <li>Social media platforms, such as Facebook</li>
        <li>Credit agencies</li>
        <li>Cookies are small files that are stored on your device when you visit a website. The cookies mean that the website will remember you and how you’ve used the site every time you visit it.</li>
      </ol>

      <h2>2. What information do we collect? Information we collect about you includes:</h2>
      <ol type="a">
        <li>your name, age, gender, nationality, address, telephone number</li>
        <li>information on how you use our products and services</li>
        <li>the location of your landline or mobile phone</li>
        <li>lifestyle information and any other information collected in relation to your use of our products and services</li>
        <li>information about your disability or impediment affecting use of our services (if applicable)</li>
        <li>your credit history</li>
      </ol>

      <p>
        This information may be held by us while you are using our services and for a period of time afterwards. We may also monitor and record your calls to us and our calls to you.
      </p>

      <h2>3. What do we use your information for?</h2>
      <ol type="a">
        <li>processing and evidencing your orders or applications</li>
        <li>carrying out credit checking and scoring (unless we have agreed otherwise)</li>
        <li>providing you with products and/or services you have requested or administering your account</li>
        <li>billing you and collecting any debt owed to us</li>
        <li>settling accounts with related service providers</li>
        <li>dealing with your requests, enquiries or complaints and other customer care related activities</li>
        <li>carrying out market and product analysis and improvements</li>
        <li>contacting you about products and services</li>
        <li>informing you about important community events</li>
        <li>registering your details for rewards and benefits</li>
        <li>assisting emergency services</li>
        <li>responding to natural disasters and civil emergencies</li>
        <li>complying with legal, governmental or regulatory requirements</li>
        <li>crime or fraud prevention</li>
        <li>personnel training and system maintenance</li>
        <li>customising your website experience</li>
        <li>general administrative and business purposes</li>
      </ol>

      <h2>4. When would we share your information to others?</h2>
      <p>
        There may be times when we need to disclose your personal information to third parties (some of which may be based outside of the Cook Islands). Our websites and systems and those of our Group companies may also be based on servers located outside of the Cook Islands. We will only disclose your information to:
      </p>

      <h2>5. What about when using our products and services outside the Cook Islands?</h2>
      <p>
        Your information may be transferred outside the Cook Islands to that country. The data protection laws of other countries may apply to how your information is handled.
      </p>

      <h2>6. How do we protect your personal information?</h2>
      <p>
        We take reasonable steps to ensure the information we collect is accurate and stored securely.
      </p>

      <h2>7. How you can protect your personal information?</h2>
      <p>
        Do not share your password. Always sign out when using a shared computer and close your browser.
      </p>

      <h2>8. How can you access and update your personal information?</h2>
      <p>
        You can request access or corrections to your information by contacting <a href="mailto:info@vodafone.co.ck">info@vodafone.co.ck</a>.
      </p>

      <h2>9. Internet use</h2>
      <p>
        We use cookies and other techniques to understand how you use our site and improve your experience. IP addresses may be collected for session management and security.
      </p>

      <h2>10. Changes to our Privacy Policy</h2>
      <p>
        We may update this Privacy Policy occasionally. Changes take effect once posted on our website.
      </p>

    </div>

    )
}

export default EMoniPrivacyPolicy;